import { ITaskDateOptions } from '@fsd-features/task/TaskForm/models/TaskForm.types';
import { IGetNextOnlineLessonsResponse } from '@fsd-shared/models/assignment';
import { EAssignedTypes, EDeadlineTypes, EDurationTypes } from '@fsd-shared/models/task';

export const getTaskDateInitialValues = (props: {
    onlyDatesOptions?: boolean;
    isTestLesson?: boolean;
    nextOnlineLessonsList?: IGetNextOnlineLessonsResponse;
}): ITaskDateOptions => {
    const { onlyDatesOptions, isTestLesson, nextOnlineLessonsList } = props;

    if (onlyDatesOptions) {
        return {
            dateStartList: [{ label: 'Дата и время', value: EAssignedTypes.DATE_TIME }],
            dateEndList: [{ label: 'Дата и время', value: EDeadlineTypes.DATE_TIME }],
        };
    }

    const baseDateStartList = [
        { label: 'Точные дата и время', value: EAssignedTypes.DATE_TIME },
        { label: 'Выдать сейчас', value: EAssignedTypes.NOW },
        { label: 'По началу онлайн-занятия', value: EAssignedTypes.TIME },
    ];
    const baseDateEndList = [
        { label: 'Точные дата и время', value: EDeadlineTypes.DATE_TIME },
        { label: 'Через время после выдачи задания', value: EDeadlineTypes.TIME },
    ];

    if (!isTestLesson) {
        baseDateStartList.push({ label: 'По окончанию занятия', value: EAssignedTypes.RELATIVE_LS_END });
    }
    const hasCurrentPeriodLessons = !!nextOnlineLessonsList?.currentPeriod?.length,
        hasNextPeriodLessons = !!nextOnlineLessonsList?.nextPeriod?.length;

    if (hasCurrentPeriodLessons || hasNextPeriodLessons) {
        const subOptionsList = [{ label: 'К следующему онлайн-занятию', value: EDeadlineTypes.UNTIL_NEXT_OL }];

        if (hasCurrentPeriodLessons) {
            subOptionsList.push({
                label: 'К онлайн-занятию в текущем периоде',
                selectable: false,
                value: 'CURR_OL',
                children: nextOnlineLessonsList?.currentPeriod?.map(({ id, title, number }) => {
                    return { label: `${number} урок - ${title}`, value: id };
                }),
            });
        }
        if (hasNextPeriodLessons) {
            subOptionsList.push({
                label: 'К онлайн занятию в следующих периодах',
                selectable: false,
                value: 'FUTURE_OL',
                children: nextOnlineLessonsList?.nextPeriod?.map(({ id, title, number }) => {
                    return { label: `${number} урок - ${title}`, value: id };
                }),
            });
        }
        // mockLessons.current.length || mockLessons.next.length
        baseDateEndList.push({
            label: 'К онлайн-занятию',
            value: EDeadlineTypes.UNTIL_SELECTED_OL,
            selectable: false,
            children: subOptionsList,
        });
    } else {
        baseDateEndList.push({ label: 'К следующему онлайн-занятию', value: EDeadlineTypes.UNTIL_NEXT_OL });
    }

    return {
        dateStartList: [
            ...baseDateStartList,
            { label: 'После выполнения всех упражнений в материалах', value: EAssignedTypes.AFTER_EXERCISES_COMPLETED },
            { label: 'После открытия материалов', value: EAssignedTypes.AFTER_MATERIALS_VIEWED },
        ],
        dateEndList: baseDateEndList,
        timeToComplete: [
            { label: 'Не ограничено', value: EDurationTypes.UNLIMITED },
            { label: 'Выбрать время', value: EDurationTypes.TIME_LIMITED },
        ],
    };
};
